import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "compact", "icon", "marginInlineEnd", "padding", "size", "textAlign", "verticalAlign"];
import { forwardRef } from 'react';
import * as stylex from '@stylexjs/stylex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { useUiVariant } from './UiVariantProvider';
import { toMarginXstyle } from './utils/foundationsSpacing';
import { jsx as _jsx } from "react/jsx-runtime";
const _temp = {
  display: "x3nfvp2",
  lineHeight: "xo5v014",
  position: "x1n2onr6",
  userSelect: "x87ps6o",
  "$$css": true
};
const _temp2 = {
  alignItems: "x6s0dn4",
  height: "xyq6l7l",
  display: "x3nfvp2",
  width: "x1uyokj7",
  justifyContent: "xl56j7k",
  "$$css": true
};
// TRELLIS-TODO: This box recreates foundations IconHolder's layout so call
// sites line up the same in both variants. We will try to remove it in favour
// of a more holistic solution (Trellis icon sizing and alignment, or layout at
// the call sites) once the migration settles.
const styles = {
  holder: (fontSize, verticalAlign) => [_temp, {
    fontSize: fontSize != null ? "xdmh292" : fontSize,
    verticalAlign: verticalAlign != null ? "x78p4oq" : verticalAlign,
    $$css: true
  }, {
    "--x-fontSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(fontSize),
    "--x-verticalAlign": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(verticalAlign)
  }],
  iconBox: size => [_temp2, {
    "--x-blockSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size),
    "--x-inlineSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size)
  }]
};
const getIconBoxSize = (compact, padding) => {
  if (compact) {
    return '1em';
  }
  return padding === undefined ? '2.25em' : '1.25em';
};
const TrellisIconHolder = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _useIconSize;
  let {
      color,
      compact = false,
      icon: Icon,
      marginInlineEnd,
      padding,
      size,
      verticalAlign = '-0.1em'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    ref: ref
  }, stylex.props(styles.holder((_useIconSize = useIconSize(size)) !== null && _useIconSize !== void 0 ? _useIconSize : null, verticalAlign), toMarginXstyle({
    marginInlineEnd
  })), {
    children: /*#__PURE__*/_jsx("span", Object.assign({}, stylex.props(styles.iconBox(getIconBoxSize(compact, padding))), {
      children: Icon && /*#__PURE__*/_jsx(Icon, {
        size: size,
        color: color
      })
    }))
  }));
});
export const CdpIconHolder = /*#__PURE__*/forwardRef((props, ref) => {
  const variant = useUiVariant();
  return variant === 'trellis' ? /*#__PURE__*/_jsx(TrellisIconHolder, Object.assign({}, props, {
    ref: ref
  })) : /*#__PURE__*/_jsx(IconHolder, Object.assign({}, props, {
    ref: ref
  }));
});